import React, { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { Button, Input } from '../ui';
import { GoogleLogin } from '@react-oauth/google';

export default function LoginPage() {
  const { login, loginWithGoogle, error, loading } = useAuth();
  const [email, setEmail] = useState('admin@postflow.ai');
  const [password, setPassword] = useState('admin123');
  const [emailErr, setEmailErr] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailErr('');
    if (!email) { setEmailErr('El email es requerido'); return; }
    await login(email, password);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-base)', padding: '16px',
      backgroundImage: 'radial-gradient(ellipse 80% 60% at 50% -10%, #1a0a2e 0%, transparent 70%), radial-gradient(ellipse 40% 40% at 80% 80%, #0a1628 0%, transparent 60%)',
    }}>
      {/* Decorative blobs */}
      <div style={{ position: 'fixed', top: '15%', left: '10%', width: '300px', height: '300px', borderRadius: '50%', background: 'radial-gradient(circle, #7c3aed15, transparent)', pointerEvents: 'none' }} />
      <div style={{ position: 'fixed', bottom: '15%', right: '10%', width: '250px', height: '250px', borderRadius: '50%', background: 'radial-gradient(circle, #2563eb15, transparent)', pointerEvents: 'none' }} />

      <div className="animate-scaleIn" style={{ width: '100%', maxWidth: '420px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            width: '80px', height: '80px', borderRadius: '20px',
            display: 'flex', alignItems: 'center',
            justifyContent: 'center', margin: '0 auto 16px',
            boxShadow: 'var(--shadow-glow)',
            overflow: 'hidden',
            background: 'transparent',
          }}>
            <img src="/thitan-logo.png" alt="TX-Flow AI" style={{ width: '80px', height: '80px', objectFit: 'contain' }} />
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '28px', fontWeight: '800', background: 'linear-gradient(90deg, #a855f7, #3b82f6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            TX-Flow AI
          </h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '14px', marginTop: '6px' }}>Automatización inteligente de redes sociales</p>
        </div>

        {/* Card */}
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl)', padding: '32px', boxShadow: 'var(--shadow-lg)' }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '20px', fontWeight: '700', marginBottom: '24px' }}>Iniciar sesión</h2>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Input
              label="Email"
              type="email"
              value={email}
              onChange={setEmail}
              placeholder="admin@postflow.ai"
              icon="✉"
              error={emailErr}
              required
            />
            <Input
              label="Contraseña"
              type="password"
              value={password}
              onChange={setPassword}
              placeholder="••••••••"
              icon="🔒"
              required
            />

            {error && (
              <div style={{ background: '#ef444415', border: '1px solid #ef444430', borderRadius: 'var(--radius-md)', padding: '10px 14px', fontSize: '13px', color: '#ef4444', display: 'flex', alignItems: 'center', gap: '8px' }}>
                ⚠️ {error}
              </div>
            )}

            <Button type="submit" loading={loading} size="lg" style={{ marginTop: '8px', width: '100%' }}>
              {loading ? 'Entrando...' : 'Entrar al dashboard'}
            </Button>
          </form>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '20px 0' }}>
            <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
            <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>o</span>
            <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <GoogleLogin
              onSuccess={(cred) => loginWithGoogle(cred.credential)}
              onError={() => {}}
              theme="filled_black"
              text="signin_with"
              shape="pill"
            />
          </div>

          {/* Demo hint */}
          <div style={{ marginTop: '20px', padding: '12px', background: 'var(--bg-elevated)', borderRadius: 'var(--radius-md)', border: '1px solid var(--border)' }}>
            <p style={{ fontSize: '12px', color: 'var(--text-muted)', textAlign: 'center', lineHeight: 1.5 }}>
              🎮 <strong style={{ color: 'var(--text-secondary)' }}>Modo demo</strong> — Las credenciales ya están precargadas
            </p>
          </div>
        </div>

        <p style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '12px', marginTop: '24px' }}>
        <p style={{ textAlign: 'center', fontSize: '13px', marginBottom: '8px' }}><a href="/register" style={{ color: 'var(--accent-primary)', fontWeight: '600', textDecoration: 'none' }}>¿No tienes cuenta? Crea una gratis</a></p>
          TX-Flow AI v1.0 · Todos los derechos reservados
        </p>
      </div>
    </div>
  );
}
